import React from 'react';
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import StopShop from "../elements/service/StopShop";
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import AboutFour from '../elements/about/AboutFour';
import EnterpriseSec from '../elements/about/EnterpriseSec';
import { useTranslation } from "react-i18next";


const EntrepriseMission = () => {
    const { t } = useTranslation('enterprise');
    const Entreprise = [
        {
            image: "/images/bg/bg-home-1.png",
            title: t('entrepriseMission.rse.title'),
        },
    ]
    return (
        <>
            <SEO title="N01ZET Entreprise à Mission - Raison d'être - RSE CSR ESG Impact" />
            <main className="page-wrapper main-mobile-responsive">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="1" >
                    {Entreprise.map((data) => (
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="inner text-left">
                                    <h1 className="title display-one cust-title big-title mt-5" dangerouslySetInnerHTML={{__html: data.title}}></h1>
                                    <p className="description" style={{ fontSize: '20px' }}></p>
                                    <div className="button-group">
                                        <Link className="btn-default btn-medium btn-icon" to="/offers">{t('footer.offres')}<i className="icon"><FiArrowRight /></i></Link>
                                        <Link className="btn-default btn-medium btn-border btn-icon cust-color" to="/contact">{t('buttons.beContacted')}<i className="icon"><FiArrowRight /></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <img style={{ marginLeft: '80px', marginTop: '80px' }} className="bannerimg" src="/images/bg/bg-enterprise.png" alt='environment'/>
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
                {/* End Slider Area  */}
                <AboutFour />
                <Separator />
                <EnterpriseSec />
                <Separator />   
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('footer.offres')}
                                    description=""
                                />
                            </div>
                        </div>
                        <StopShop
                            serviceStyle="service__style--1 radius mt--20 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default EntrepriseMission
